import { Injectable } from '@angular/core';

import { SessionStorageService } from '../../../../core/services/web-storage';
import { TipoArquivoFilter } from './tipo-arquivo-filter';
import { TipoArquivoFilterStorage } from './tipo-arquivo-filter-storage';

/**
 * Service utilizado para armazenar os dados do filter dos tipos de arquivos no session storage do navegador
 */
@Injectable({
    providedIn: 'root'
})
export class TipoArquivoFilterStorageService {
    constructor(private sessionStorageService: SessionStorageService) { }


    /** Obtem os dados do filtro armazenados */
    get(key: string): TipoArquivoFilterStorage {
        const data = this.sessionStorageService.getObject(key) as TipoArquivoFilterStorage;
        if (data) {
            // Criando um Map com os campos filtrados e seus respectivos valores
            data.filterValues = new Map();
            const keys = Object.keys(data.filter);
            keys.forEach(key => data.filterValues.set(key, data.filter[key]));
        }

        return data;
    }

    /** Armazena os dados do filtro */
    set(key: string, filter: TipoArquivoFilter) {
        const data = new TipoArquivoFilterStorage(filter);
        this.sessionStorageService.setObject(key, data);
    }

    /** Remove os dados do filtro */
    remove(key: string) {
        this.sessionStorageService.remove(key);
    }

    /** Verifica se possui filtro salvo no storage */
    hasFilter(key: string): boolean {
        const filter = this.get(key);
        return filter != null && filter !== undefined;
    }

    /** Aplica o filtro armazenado no objeto do filtro informado */
    applyFilter(key: string, filter: TipoArquivoFilter) {
        const filterStorage = this.get(key);
        if (filterStorage != null) {
            // Se possuir os dados, então setamos o filtro com os seus valores armazenados
            if (filter) {
                filterStorage.filterValues.forEach((value, key) => filter[key] = value);
            }
        }
    }
}
